// National accounts whose retail sites say "Cart" instead of "Quote" on the add/remove buttons (TW-1134). Keyed by
// account rather than site template because most BMW dealers still carry the legacy "bmw" template value, which loads
// the universal template.
const cartWordingNationalAccountIds = new Set(["11"]);

export const usesCartWording = (dealerNationalAccountId: string): boolean =>
  cartWordingNationalAccountIds.has(dealerNationalAccountId);
